export default "__VITE_ASSET__mKBOnYnZ__"